import { Button } from "@/components/ui/button.tsx"
import { Plus, Save, Columns2, Wallet } from "lucide-react"

interface SplitFormHeaderProps {
  isReadyToSave: boolean
  onAddSplit: () => void
  onAutoSplit: () => void
  /** Split the parsed backup by accrual-bank customer bucket (slotting vs promo by discount %). */
  onBucketSplit?: () => void
  onSave: () => void
}

export function SplitFormHeader({ 
  isReadyToSave, 
  onAddSplit,
  onAutoSplit,
  onBucketSplit,
  onSave 
}: SplitFormHeaderProps) {
  return (
    <div className="px-4 sticky top-0 z-10 bg-white pb-2">
      <div className="flex justify-between items-center">
        <div className="flex gap-2">
          <Button onClick={onAddSplit} variant="outline" className="h-8 px-3 text-sm">
            <Plus className="h-4 w-4 mr-2"/>
            Add Split
          </Button>
          <Button onClick={onAutoSplit} variant="outline" className="h-8 px-3 text-sm">
            <Columns2 className="h-4 w-4 mr-2"/>
            Custom Split from Parsed Backup
          </Button>
          {onBucketSplit && (
            <Button onClick={onBucketSplit} variant="outline" className="h-8 px-3 text-sm" title="Group the parsed backup by accrual-bank customer bucket">
              <Wallet className="h-4 w-4 mr-2"/>
              Split by Customer Bucket
            </Button>
          )}
          <Button 
            onClick={onSave} 
            variant={isReadyToSave ? "default" : "outline"} 
            className={`h-8 px-3 text-sm ${isReadyToSave ? "bg-green-600 hover:bg-green-700 text-white" : ""}`}
            disabled={!isReadyToSave}
          >
            <Save className="h-4 w-4 mr-2"/>
            Save All
          </Button>
        </div>
      </div>
    </div>
  )
}
